const constituentFuntions = {
    morpheme : (result) => {

        const resultArr = [];
        for (let i = 0; i < result.length; i++) {
          const txt = result[i].text;
          if (
            txt === "_s" ||
            txt === "_m" ||
            txt === "_re" ||
            txt === "_d" ||
            txt === "_ll" ||
            txt === "_ve"
          ) {
            resultArr.push(txt.replace("_", "'"));
            continue;
          }
          if (txt === "egg.") {
            resultArr.push("egg");
            continue;
          }
          if (txt === "no.") {
            resultArr.push("no");
            continue;
          }
          if (txt.indexOf("Mr._") === 0 && txt[4] === txt[4].toUpperCase()) {
            result.splice(i, 0, JSON.parse(JSON.stringify(result[i])));
            result[i].text = "Mr.";
            result[i + 1].text = txt.replace("Mr._", "");
            resultArr.push("Mr.");
            continue;
          }
          if (txt.indexOf("Mrs._") === 0 && txt[5] === txt[5].toUpperCase()) {
            result.splice(i, 0, JSON.parse(JSON.stringify(result[i])));
            result[i].text = "Mrs.";
            result[i + 1].text = txt.replace("Mrs._", "");
            resultArr.push("Mrs.");
            continue;
          }
          if (txt === "because_of") {
            result.splice(i, 0, JSON.parse(JSON.stringify(result[i])));
            result[i].text = "because";
            result[i + 1].text = "of";
            resultArr.push("because");
            continue;
          }
          if (i !== 0 && txt === "can_" && result[i + 1].text === "_not") {
            result.splice(i + 1, 1);
            resultArr.push("cannot");
            continue;
          }
          if (i !== 0 && txt === "can_" && result[i + 1].text === "_n't") {
            resultArr.push("ca");
            continue;
          }
          if (i !== 0 && txt === "will_" && result[i + 1].text === "_n't") {
            resultArr.push("wo");
            continue;
          }
          if (
            i !== 0 &&
            result[i - 1].text === "have" &&
            result[i - 1].reason === "P:v-fin('have' PR -3S)" &&
            txt === "to"
          ) {
            result[i].morpheme = "verb";
            resultArr.push("to");
            continue;
          }
          resultArr.push(txt.replace("_", ""));
        }
        // const resultArr = result.map((ele, idx) => {
        //   const txt = ele.text;
        //   if (
        //     txt === "_s" ||
        //     txt === "_m" ||
        //     txt === "_re" ||
        //     txt === "_d" ||
        //     txt === "_ll" ||
        //     txt === "_ve"
        //   ) {
        //     return txt.replace("_", "'");
        //   }
        //   if (txt === "egg.") {
        //     return "egg";
        //   }
        //   if (txt === "no.") {
        //     return "no";
        //   }
        //   if (txt === "because_of") {
        //     result.splice(idx,0,JSON.parse(JSON.stringify(result[idx])))
        //     result[idx].text = 'because'
        //     result[idx+1].text = 'of'
        //     return 'because'
        //   }
        //   if (idx !== 0 && txt === "can_" && result[idx+1].text === "_not") {
        //     result.splice(idx+1,1)
        //     return "cannot"
        //   }
        //   if (idx !== 0 && txt === "can_" && result[idx+1].text === "_n't") {
        //     return "ca"
        //   }
        //   if (idx !== 0 && txt === "will_" && result[idx+1].text === "_n't") {
        //     return "wo"
        //   }
        //   if (idx !== 0 && result[idx-1].text === 'have' && result[idx-1].reason === "P:v-fin('have' PR -3S)" && txt === 'to') {
        //     result[idx].morpheme = 'verb'
        //     return 'to'
        //   }
        //   return txt.replace("_", "");
        // });
        // console.log("API대조값:", resultArr);
        // console.log(resultArr[0],resultArr[1])
        return resultArr
    },

}

export default constituentFuntions